import request from '@/utils/request';

const swHead = '/api';

export const projectController = {
  // 获取列表
  // list: () => request.get(`${swHead}/project`),
  // rename: (data) => request.post(`${swHead}/project/${data.projectId}/name`, data.body),
  // delete: (data) => request.delete(`${swHead}/project/${data.projectId}`),
  // detail: (data) => request.get(`${swHead}/project/${data.projectId}`),
  // export: (data) => request.post(`${swHead}/project/${data.projectId}/export`, data.body),
  // sentenceOp: (data) => request.post(`${swHead}/project/${data.projectId}/sentenceOp`, data.body),
  // background: (data) => request.post(`${swHead}/project/${data.projectId}/background`, data.body),
  // chooseVoice: (data) =>
  //   request.post(`${swHead}/project/${data.projectId}/choose-voice`, data.body),
  // layout: (data) => request.post(`${swHead}/project/${data.projectId}/layout`, data.body),
  // aspect: (data) => request.post(`${swHead}/project/${data.projectId}/aspect`, data.body),
  // subtitleStyle: (data) =>
  //   request.post(`${swHead}/project/${data.projectId}/subtitleStyle`, data.body),
  // subtitleBox: (data) => request.post(`${swHead}/project/${data.projectId}/subtitleBox`, data.body),
  // exportProject: (data) => request.post(`${swHead}/project/${data.projectId}/export`, data.body),
  // download: (data) => request.get(`${swHead}/project/${data.projectId}/download`),
  // undo: (data) => request.post(`${swHead}/project/${data.projectId}/undo`, data.body),
  // redo: (data) => request.post(`${swHead}/project/${data.projectId}/redo`, data.body),
  // generateAll: (data) => request.post(`${swHead}/project/${data.projectId}/generateAll`, data.body),
  // discardAll: (data) => request.post(`${swHead}/project/${data.projectId}/discardAll`, data.body),
  // thumbnail: (data) => request.post(`${swHead}/project/${data.projectId}/thumbnail`, data.body),
  // lipSync: (data) => request.get(`${swHead}/project/${data.projectId}/lipSync?value=${data.value}`),
  // style: (data) => request.post(`${swHead}/style/${data.projectId}`, data.body),
  // subtitleKey: (data) => request.post(`${swHead}/project/${data.projectId}/subtitleKey`, data.body),
  session: (data) => request.post(`${swHead}/project/${data.projectId}/session`),
  detail: (data) => request.get(`${swHead}/project/${data.projectId}`),
  layoutIndex: (data) => request.put(`${swHead}/project/${data.projectId}/index`, data.body),
  background: (data) => request.post(`${swHead}/project/${data.projectId}/background`, data.body),
  style: (data) => request.post(`${swHead}/style/${data.projectId}`, data.body),
  diyLayout: (data) => request.put(`${swHead}/project/${data.projectId}/diy-layout`, data.body),
  diySubtitle: (data) => request.post(`${swHead}/diy-subtitle/${data.projectId}`, data.body),
  subtitleStyle: (data) =>
    request.post(`${swHead}/project/${data.projectId}/subtitleStyle`, data.body),
  updateSubtitleShow: (data) =>
    request.post(`${swHead}/project/${data.projectId}/updateSubtitleShow`, data.body),
  subtitleBox: (data) => request.post(`${swHead}/project/${data.projectId}/subtitleBox`, data.body),
  timelineOp: (data) => request.post(`${swHead}/project/${data.projectId}/timelineOp`, data.body),
  addSpeaker: (data) => request.post(`${swHead}/speaker/${data.projectId}`),
  editSpeaker: (data) => request.put(`${swHead}/project/speaker/${data.id}`, data.body),
  getSpeakerList: (data) => request.get(`${swHead}/speaker/list/${data.projectId}`),
  translate: (data) => request.post(`${swHead}/project/${data.projectId}/translate`, data.body),
  exportProject: (data) => request.post(`${swHead}/project/${data.projectId}/export`, data.body),
  addSubtitle: (data) => request.post(`${swHead}/project/${data.projectId}/addSubtitle`, data.body),
  deleteSubtitles: (data) =>
    request.post(`${swHead}/project/${data.projectId}/deleteSubtitles`, data.body),
  updateCharNum: (data) =>
    request.get(`${swHead}/project/${data.projectId}/updateCharNum?charNum=${data.charNum}`),
  batchTts: (data) =>
    request.get(`${swHead}/project/${data.projectId}/batchTts?sessionId=${data.sessionId}`),
  diySubtitle: (data) => request.post(`${swHead}/diy-subtitle/${data.projectId}`, data.body),
  updateFontSize: (data) =>
    request.post(`${swHead}/project/${data.projectId}/updateFontSize`, data.body),
  batchTranslation: (data) =>
    request.get(`${swHead}/project/${data.projectId}/batchTranslation?sessionId=${data.sessionId}`),
};

export const voiceController = {
  // 获取列表
  assetsList: (data) => request.get(`${swHead}/voice${data ? '/' + data : ''}`),
  rename: (data) => request.post(`${swHead}/voice/${data.voiceNum}/name`, data.body),
  // 删除
  delete: (data) => request.delete(`${swHead}/voice/${data.voiceNum}`),
  add: (data) => request.post(`${swHead}/voice`, data),
};

export const popupController = {
  popUpRecord: (data) => request.put(`${swHead}/popUpRecord`, data.body),
};
